import {
  Assignment as ProjekteIcon,
  AssignmentTurnedIn as AufwaendeIcon,
  People as MitarbeiterIcon,
  Security as SecurityIcon,
} from '@mui/icons-material';
import { Box, LinearProgress } from '@mui/material';
import { endOfMonth, startOfDay } from 'date-fns';
import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { formatName } from '../../../components/formatUtils';
import { PlainEntityDetailsHeader } from '../../../components/plainEntityDetailsHeader/PlainEntityDetailsHeader';
import { RouterTabs } from '../../../components/routerTabs/RouterTabs';
import { AufwandTable } from '../../aufwand/list/AufwandTable';
import { MitarbeiterRole } from '../../auth/api/types';
import { ProjektTableForMitarbeiter } from '../../projekt/list/ProjektTableForMitarbeiter';
import { useFindMitarbeiterByIdQuery } from '../api/mitarbeiterApi';

import { MitarbeiterSecurityCard } from './MitarbeiterSecurityCard';
import { MitarbeiterStammdatenCard } from './MitarbeiterStammdatenCard';

export const MitarbeiterViewScreen: FC = () => {
  const { id } = useParams();
  const { data: mitarbeiter, isLoading } = useFindMitarbeiterByIdQuery(id as string);

  return (
    <Box>
      {isLoading && <LinearProgress sx={{ width: '100%' }} />}
      {mitarbeiter && (
        <>
          <PlainEntityDetailsHeader
            title={`${formatName(mitarbeiter, false)}${mitarbeiter.role === MitarbeiterRole.ADMIN ? ' (Admin)' : ''}`}
            createdAt={mitarbeiter.creationDate}
            updatedAt={mitarbeiter.updateDate}
          />
          <RouterTabs
            tabs={[
              {
                index: true,
                path: 'mitarbeiter',
                label: 'Mitarbeiter',
                icon: <MitarbeiterIcon />,
                content: (
                  <Box
                    sx={{
                      width: '50%',
                    }}
                  >
                    <MitarbeiterStammdatenCard mitarbeiter={mitarbeiter} />
                  </Box>
                ),
              },
              {
                path: 'projekte',
                label: 'Projekte',
                icon: <ProjekteIcon />,
                content: <ProjektTableForMitarbeiter mitarbeiterId={mitarbeiter.id} />,
              },
              {
                path: 'aufwaende',
                label: 'Aufwände',
                icon: <AufwaendeIcon />,
                content: (
                  <AufwandTable
                    initialFilterItems={{
                      mitarbeiterId: id ? { value: id, operator: 'equal' } : undefined,
                      datum: {
                        from: startOfDay(new Date()).toISOString(),
                        to: endOfMonth(new Date()).toISOString(),
                        operator: 'between',
                      },
                    }}
                    stackProps={{ sx: { height: 'auto' } }}
                  />
                ),
              },
              {
                path: 'sicherheit',
                label: 'Sicherheit',
                icon: <SecurityIcon />,
                content: (
                  <Box
                    sx={{
                      width: '50%',
                    }}
                  >
                    <MitarbeiterSecurityCard mitarbeiter={mitarbeiter} />
                  </Box>
                ),
              },
            ]}
          />
        </>
      )}
    </Box>
  );
};
